module.exports = __webpack_public_path__ + "static/media/SingleShift.8af18a93.svg";